<template>
  <div id="app" class="min-h-screen bg-[var(--cream)] dark:bg-[var(--deep-charcoal)] flex flex-col">
    <!-- Header -->
    <!-- <MainHeader :navScrolled="navScrolled" /> -->
    <HeaderSection v-if="!isBioOnly" />

    <!-- Main Content -->
    <main :class="['flex-1', { 'main-below-header': !isBioOnly }]">
      <!-- Show router-view for unauthenticated routes -->
      <router-view v-if="!$route.meta.requiresAuth" />
      
      <!-- Show BodySection for authenticated routes -->
      <BodySection v-if="$route.meta.requiresAuth" />
    </main>
    
    <!-- Footer -->
    <MainFooter />
    
    <!-- WhatsApp Button -->
    <WhatsAppButton />
    
    <!-- Scroll to Top Button -->
    <button
      v-show="showScrollTop"
      @click="scrollToTop"
      class="floating-action-btn fixed bottom-6 right-6 z-50"
      aria-label="Scroll to top"
    >
      <span class="material-symbols-outlined text-lg">keyboard_arrow_up</span>
    </button>
  </div>
</template>

<script>
// import MainHeader from "./components/MainHeader.vue";
import MainFooter from "./components/MainFooter.vue";
import WhatsAppButton from "./components/WhatsAppButton.vue";
import BodySection from "./components/shop/BodySection.vue";
import HeaderSection from "./components/HeaderSection.vue";
import { isBioOnlyDomain } from "@/utils/siteMode";

export default {
  components: {
    // MainHeader,
    MainFooter,
    WhatsAppButton,
    BodySection,
    HeaderSection,
  },
  data() {
    return {
      showScrollTop: false,
      navScrolled: false,
    };
  },
  computed: {
    isBioOnly() {
      return isBioOnlyDomain();
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // Enable dark mode by default
    document.documentElement.classList.add('dark');
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleScroll() {
      this.navScrolled = window.pageYOffset > 50;
      this.showScrollTop = window.pageYOffset > 300;
    },
  },
};
</script>

<style scoped>
/* Import Google Fonts for consistency */
@import url("https://fonts.googleapis.com/css2?family=Caveat:wght@400;500&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600&display=swap");

/* Font classes */
.font-handwriting {
  font-family: "Caveat", cursive;
}

.font-serif {
  font-family: "Playfair Display", serif;
}

.font-sans {
  font-family: "Montserrat", sans-serif;
}

.main-below-header {
  padding-top: var(--app-header-height);
}
</style>
